import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_UPDATE_VEHICLE_DATA_REQUEST = `${VEHICLE_MODULE_PREFIX}_UPDATE_VEHICLE_DATA_REQUEST`;
export const VEHICLE_UPDATE_VEHICLE_DATA_SUCCESS = `${VEHICLE_MODULE_PREFIX}_UPDATE_VEHICLE_DATA_SUCCESS`;
export const VEHICLE_UPDATE_VEHICLE_DATA_FAILURE = `${VEHICLE_MODULE_PREFIX}_UPDATE_VEHICLE_DATA_FAILURE`;
/**
 * Action creator to dispatch an action to save vehicle data for the given job id
 * @param payload jobId guid, jobVehicleData: SAGASERVICEONLY_IVehicle
 * @returns
 */
export const onUpdateVehicleDataRequest = (payload) => ({
    type: VEHICLE_UPDATE_VEHICLE_DATA_REQUEST,
    payload
});
/**
 * Action creator to notify on save vehicle data to server. For new job, it returns vehicle ID
 * @param payload number state data
 * @returns
 */
export const onUpdateVehicleDataSuccess = () => ({
    type: VEHICLE_UPDATE_VEHICLE_DATA_SUCCESS,
    payload: null
});
/**
 * Action creator to handle error occurred while saving vehicle to server
 * @param failureMessage string
 * @returns
 */
export const onUpdateVehicleDataFailure = (failureMessage) => ({
    type: VEHICLE_UPDATE_VEHICLE_DATA_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=updateVehicleDataActions.js.map